import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import TextContentsApi from '../generated/api/TextContents';

export default (service: Servicelayer) => ({
  ...TextContentsApi(service),

  // Add custom calls here

});
